
import AppData from './AppData';

export const VariationSelectionType = {
    YES_NO: 1,
    QUANTITY: 2,
}

export const VariationSelectionTypeHint = {
    [VariationSelectionType.YES_NO]     : () => lang.yes_no,
    [VariationSelectionType.QUANTITY]   : () => lang.quantity_adjust,
}

export const VariationType = {
    SIDE_DISH: 2,
    OPTION: 0,
    CHOICE: 1,
}

export const VariationTypeMap = {
    [VariationType.SIDE_DISH]   : "title_side_dish",
    [VariationType.CHOICE]      : "title_choice",
    [VariationType.OPTION]      : "item_variations",
}
class Variation {
    getCategory = () => {

    }
    getMenuItem = (useCache = false) => {

    }
    isSideDish = () => {
        // return this.
    }
    getInventoryQuantity = () => {
        return parseInt(this.inventory_quantity || 0)
    }
    isNegativeStock = () => {
        return this.track_inventory && this.getInventoryRemainingQuantity() < 0
    }
    isInfiniteInventory = () => {
        return !this.track_inventory
    }
    checkIsOutOfStock = () => {
        if (window.skip_out_of_stock_check) {
            return false
        }
        const isInventoryModuleEnabled = AppData.data.isInventoryModuleEnabled()

        // Simple check of isOutOfStock, based on DB flag
        if (this.is_out_of_stock) {
            return true
        }
        if (isInventoryModuleEnabled) {
            return this.menuItemInventoryOutOfStock()
        }
    }
    inventoryOutOfStock = () => {
        if (this.track_inventory) {
            if (this.isHasChoice()) {
                return false
            }
            else {
               return this.getInventoryRemainingQuantity() <= 0
            }
        }
        return false
    }
    getInventoryRemainingQuantity = () => {
        let draftOrderItemQuantity = this.getDraftOrderItemQuantity()
        let calculatedQuantity = this.getInventoryQuantity() - draftOrderItemQuantity
        return calculatedQuantity
    }
    getDraftOrderItemQuantity = () => {
        const adminOrders = AppData.data.state.adminOrders
        let draftOrderItemQuantity = 0
        adminOrders.filter(order => order.order_status == "draft").forEach(order => {
            if (this.type == VariationType.CHOICE) {
                if (order.option_ids && order.option_ids[0] == this.id) {
                    draftOrderItemQuantity += order.quantity
                }
            }
            else {
                if (order.variation_ids && order.variation_ids != "") {
                    let variationIds = order.variation_ids.split(",").map(id => parseInt(id))
                    if (variationIds.indexOf(this.id) !== -1) {
                        draftOrderItemQuantity += order.quantity
                    }
                }
            }
        })
        return draftOrderItemQuantity
    }

    static getDefaultSelectionType = (variation) => {
        return variation.type == VariationType.SIDE_DISH ? VariationSelectionType.QUANTITY : VariationSelectionType.YES_NO
    }
}
export default Variation;